// Lib
import { createSelector } from 'reselect';

// Selectors
import { isPublishPreviewModeEnabledSelector } from '../../preview/previewSelector';
import {
    currentBoardUnconstrainedUserPermissions,
    currentBoardUserPermissionsSelector,
} from '../../../utils/permissions/elementPermissionsSelector';

export const selectBoardPermissionToastPermissions = createSelector(
    currentBoardUnconstrainedUserPermissions,
    currentBoardUserPermissionsSelector,
    isPublishPreviewModeEnabledSelector,
    (unconstrainedPermissions, userPermissions, isPublishPreview) =>
        isPublishPreview ? userPermissions : unconstrainedPermissions,
);
